module.exports = __webpack_public_path__ + "static/media/pawsnfind_home_BG.f62cee97.png";